var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-text menu-link menu-link--iconed menu-link--user",on:{"click":_vm.toggleSidebar}},[_c('i',{staticClass:"icon icon--notransform user-icon icon-profile"}),_c('span',[_vm._v(_vm._s(_vm._('Мій акаунт')))])])}
var staticRenderFns = []

export { render, staticRenderFns }